import { useState } from 'react';
import { Upload, FileText, CheckCircle, X } from 'lucide-react';
import Button from '../../../components/ui/Button';

const DocumentUpload = ({ status, transactionRef }) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      // Simulate upload process
      setUploading(true);
      setTimeout(() => {
        setUploadedFile({
          name: file?.name,
          size: (file?.size / 1024)?.toFixed(2) + ' KB',
          uploadedAt: new Date()
        });
        setUploading(false);
      }, 2000);
    }
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
  };

  if (status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-6">
        <div className="flex items-center gap-3">
          <CheckCircle className="w-6 h-6 text-green-600" />
          <div>
            <h3 className="font-semibold text-green-900">Documentación Verificada</h3>
            <p className="text-sm text-green-700">Tu comprobante de pago ha sido verificado exitosamente</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border shadow-sm p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">
        Comprobante de Pago
      </h3>

      {!uploadedFile ? (
        <div className="border-2 border-dashed border-muted rounded-lg p-8 text-center">
          <div className="flex flex-col items-center gap-4">
            <div className="p-4 bg-primary/10 rounded-full">
              <Upload className="w-8 h-8 text-primary" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground mb-1">
                Sube tu comprobante de pago
              </p>
              <p className="text-xs text-muted-foreground mb-4">
                Formatos aceptados: PNG, JPG, PDF (Máx. 5MB)
              </p>
            </div>
            <label htmlFor="file-upload">
              <Button 
                as="span"
                iconName="Upload"
                loading={uploading}
                disabled={uploading}
              >
                {uploading ? 'Subiendo...' : 'Seleccionar Archivo'}
              </Button>
              <input
                id="file-upload"
                type="file"
                className="hidden"
                accept=".png,.jpg,.jpeg,.pdf"
                onChange={handleFileChange}
                disabled={uploading}
              />
            </label>
          </div>
        </div>
      ) : (
        <div className="border border-muted rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 rounded-lg">
                <FileText className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{uploadedFile?.name}</p>
                <p className="text-xs text-muted-foreground">{uploadedFile?.size}</p>
              </div>
            </div>
            <button
              onClick={handleRemoveFile}
              className="p-1 hover:bg-muted rounded-full transition-colors"
            >
              <X className="w-5 h-5 text-muted-foreground" />
            </button>
          </div>
          <div className="mt-4 pt-4 border-t">
            <div className="flex items-center gap-2 text-sm text-green-600">
              <CheckCircle className="w-4 h-4" />
              <span>Comprobante recibido - En proceso de verificación</span>
            </div>
          </div>
        </div>
      )}

      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-900">
          <strong>Nota:</strong> Asegúrate de que tu comprobante incluya la referencia de transacción <span className="font-mono font-semibold">{transactionRef}</span> para una verificación más rápida.
        </p>
      </div>
    </div>
  );
};

export default DocumentUpload;